import styled from "styled-components";
import { useEffect } from "react";

import { gql, useQuery } from "@apollo/client";
import { captureException } from "@sentry/react";
import { useNavigate } from "react-router-dom";

import AdvertisingPlans from "./AdvertisingPlans";
import LoadingBox from "components/other/LoadingBox";
import BoxLoadingSpinner from "components/other/BoxLoadingSpinner";

export default () => {
  const navigate = useNavigate();

  // Fetch ad plan billing data
  const GET_AD_PLAN_BILLING_DATA = gql`
    query GetAdPlanBillingData {
      adPlanBillingData {
        prices {
          product
          price
        }
        vatRate
        adPlan
      }
    }
  `;

  const { data, error } = useQuery(GET_AD_PLAN_BILLING_DATA, {
    fetchPolicy: "network-only",
  });

  if (error) {
    console.log("Fetching ad plan billing data error", error);
    captureException(error);
  }

  // Fetch ad plan billing data
  const GET_RECENT_AD_PLAN_PAYMENTS_DATA = gql`
    query GetRecentAdPlanPaymentsData {
      recentAdPlanPayments {
        recentPayments {
          created_at
          item
          username
          profile_image
          reccuring
        }
      }
    }
  `;

  const { data: recentPaymentsData, error: recentPaymentsError } = useQuery(
    GET_RECENT_AD_PLAN_PAYMENTS_DATA,
    {
      fetchPolicy: "network-only",
    }
  );

  if (recentPaymentsError) {
    console.log("Fetching recent payments data error", recentPaymentsError);
    captureException(recentPaymentsError);
  }

  // redirect if has active ad plan
  useEffect(() => {
    if (data) {
      if (data.adPlanBillingData.adPlan > 0) navigate("/ad-plan");
    }
  }, [data]);

  const onPlanSelect = (plan) => {
    navigate(`/review-ad-plan?plan=${plan}`);
  };

  //console.log("data", data);
  //console.log("recentPaymentsData", recentPaymentsData);

  return (
    <>
      {(!data || !recentPaymentsData) && (
        <LoadingBox>
          <BoxLoadingSpinner height="230px" />
        </LoadingBox>
      )}
      {data && recentPaymentsData && (
        <AdvertisingPlans
          data={data}
          onPlanSelect={onPlanSelect}
          recentPaymentsData={recentPaymentsData}
        />
      )}
    </>
  );
};
